import './stylesheet.css';
import Utility from './components/utility';

await Utility.load();